import React from 'react';
import { Card } from 'react-bootstrap';

import { SuperAdminOverdueTab } from '../../components/SuperAdminPanel/SuperAdminOverdueTab';

export const OverdueInvoicesView: React.FC = () => {
  return (
    <Card>
      <Card.Body>
        <SuperAdminOverdueTab />
      </Card.Body>
    </Card>
  );
};
